import { usePrefs } from "@/lib/prefs-store";
import { formatQuantity, type Quantity } from "@/lib/units";

/**
 * SPEC 4.8 — wraps every numeric value rendered in user-facing copy.
 * Reads units preference from the prefs store (placeholder until
 * AthleteProfile.units_preference loads from DB in build week 2).
 *
 * Renders mono primary; in metric_with_imperial_secondary mode, the secondary
 * unit appears in --fg-3 (per SPEC 5.10 example: "21°C (70°F)").
 */

export function UnitsRender({
  q,
  monoClass = "mono",
}: {
  q: Quantity;
  monoClass?: string;
}) {
  const { units } = usePrefs();
  const { primary, secondary } = formatQuantity(q, units);
  return (
    <span style={{ whiteSpace: "nowrap" }}>
      <span className={monoClass}>{primary}</span>
      {secondary && (
        <>
          {" "}
          <span
            className={monoClass}
            style={{ color: "var(--fg-3)", fontSize: "0.92em" }}
          >
            ({secondary})
          </span>
        </>
      )}
    </span>
  );
}
